function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("path", {
  fill: "#24626B",
  d: "M19.978 10.075a.455.455 0 0 0-.358-.32l-4.985-.763-2.229-4.732a.445.445 0 0 0-.4-.26c-.17 0-.326.1-.401.26l-2.23 4.732-4.982.752a.454.454 0 0 0-.372.323.484.484 0 0 0 .125.49l3.605 3.695-.85 5.198a.482.482 0 0 0 .178.46.43.43 0 0 0 .472.035l4.454-2.458 4.457 2.457a.43.43 0 0 0 .472-.036.48.48 0 0 0 .177-.46l-.852-5.196 3.606-3.695a.485.485 0 0 0 .113-.482z"
}));

var SvgIconRewardsStar = function SvgIconRewardsStar(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 24 24"
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgIconRewardsStar;